import { useMemo } from "react";
import {
  WSForm,
  WSInputTextarea,
  WSInputTextareaProps
} from "@wingspanhq/fe-component-library";

type Props = {
  /** Field name for the form. Defaults to "comment" */
  name?: string;
  /** Label text. Defaults to "Comment (optional)" */
  label?: string;
  /** Description shown below the label. Use {contractorName} placeholder pattern */
  description: string;
  /** Placeholder text for the textarea */
  placeholder?: string;
  /** Number of textarea rows. Defaults to 3 */
  rows?: number;
};

export const PublicCommentField: React.FC<Props> = ({
  name = "comment",
  label = "Comment (optional)",
  description,
  placeholder = "Provide specific details about the decision",
  rows = 3
}) => {
  const componentProps = useMemo<Partial<WSInputTextareaProps>>(
    () => ({
      helperText: description,
      pill: { icon: "view", text: "Public", theme: "neutral" },
      placeholder,
      rows
    }),
    [description, placeholder, rows]
  );

  return (
    <WSForm.Field
      name={name}
      label={label}
      component={WSInputTextarea}
      componentProps={componentProps}
    />
  );
};
